import { AG_GridCustomizedTableHeaders_Key, Provider_PurchaseHistory_AgGrid } from '../../../misc/tableHeaders'
import POImport from './POImport'
import _ from 'lodash'
import purchaseHistoryService from '../../../services/provider/purchase-history'

export default {
    components: {
        POImport
    },
    data() {
        return {
            total: 0,
            items: [],
            searchQuery: { pageNumber: 1, pageSize: 50, sort: null, colId: null },
            globalSearchText: '',
            searchTimer: null,
            columnDefs: [],
            gridOptions: {
                rowModelType: 'serverSide',
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
                getContextMenuItems: this.getContextMenuItems,
            },
            rowModelType: 'serverSide',
            defaultColDef: {
                sortable: true,
                resizable: true,
                filter: true,
                flex: 1,
            },
            gridApi: null,
            columnApi: null,
            poImportKey: 0,
        }
    },
    beforeMount() {
        this.columnDefs = Provider_PurchaseHistory_AgGrid
    },
    beforeDestroy() {
        if (this.searchTimer) {
            clearTimeout(this.searchTimer)
        }
    },
    methods: {
        onCellClicked(params) {
            if (params.column.colId === 'action') {
                if (params.event.target.dataset.action === 'download') {
                    this.downloadFile(params.data)
                }
            }
        },
        onFilterChanged(event) {
            this.fetchData(event)
        },
        onSortChanged(event) {
            this.fetchData(event)
        },
        debounceInput: _.debounce(function (searchStr) {
            this.searchQuery.pageNumber = 1
            this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
        }, 500),
        onGlobalSearchInput(searchValue) {
            this.globalSearchText = searchValue
            this.debounceInput(searchValue)
        },
        fetchData(params) {
            let that = this
            that.gridApi = params.api
            that.columnApi = params.columnApi
            const filterModel = that.gridApi.getFilterModel()
            that.searchQuery.colId = params.request?.sortModel[0]?.colId
            that.searchQuery.sort = params.request?.sortModel[0]?.sort
            const datasource = {
                getRows(params) {
                    purchaseHistoryService.getPurchaseHistory({
                        search: that.globalSearchText,
                        ...that.searchQuery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        filterModel,
                    }).then((resp) => {
                        if (resp && resp.data) {
                            that.items = resp.data.d.c
                            that.total = resp.data.d.t
                            if (that.total === 0 || that.total === undefined) {
                                that.gridApi.showNoRowsOverlay()
                            } else {
                                that.gridApi.hideOverlay()
                            }
                            params.successCallback(resp.data.d.c, resp.data.d.t)
                        } else {
                            params.failCallback()
                            that.total = 0
                        }
                    }).catch(() => {
                        params.failCallback()
                        that.total = 0
                    })
                }
            }
            params.api.setServerSideDatasource(datasource)
        },
        getContextMenuItems(params) {
            let that = this
            const defaultItems = params.defaultItems
            const filteredItems = defaultItems.filter((item) => item !== 'export')
            const filterModel = that.gridApi.getFilterModel()
            const customMenuItem = {
                name: 'Excel Export',
                action: async function () {
                    const email = that.$store.state.user.email
                    const query_param = {
                        ...that.searchQuery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        filterModel,
                        email: email,
                        globalSearchText: that.globalSearchText,
                    }
                    const resp = await purchaseHistoryService.downloadPurchaseHistoryXLSX(query_param)
                    if (!resp.error) {
                        that._showOk(resp.data.d.message, {
                            variant: 'success',
                            title: 'Message',
                            buttonTitle: 'Ok',
                        })
                    }
                },
                icon: '<span class="ag-icon ag-icon-excel"></span>',
            }
            return [...filteredItems, customMenuItem]
        },
        downloadFile(rowData) {
            purchaseHistoryService.downloadPOImportFile(rowData.id).then(resp => {
                if (resp && resp.data) {
                    console.log('File download response:', resp)
                    window.open(resp.data.d.data, '_blank')
                }
            })
        },
        uploadFile() {
            this.poImportKey += 1
            this.$nextTick(() => {
                if (this.$refs.poImport) {
                    this.$refs.poImport.forceRerenderInsert()
                }
            })
        },
    },
}
